import { catchAxiosError } from 'utilities/axios';
import axios from 'axios';
import { API_URL } from 'utilities/constants';

export const userRegistration = async (payload, pricePlan) => {
  payload['pricePlan'] = pricePlan;
  return catchAxiosError(
    axios
      .post(`${API_URL}auth/email/register`, payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const confirmEmail = async (payload) => {
  return catchAxiosError(
    axios
      .post(`${API_URL}auth/email/confirm`, payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const forgetPassword = async (payload) => {
  return catchAxiosError(
    axios
      .post(`${API_URL}auth/forgot/password`, payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};
